<template>
<div>
  <div>
    <div class="video-container" @click="$root.$emit('bv::hide::popover')">
      <video class="myVideo" ref="vidView" autoplay muted playsinline></video>

      <div v-if="mainState === 'pre'">
        <div class="liveIndicator">Starting the default camera...</div>
        <b-button  @click.prevent="goBack()" class="mainButton preLive">X</b-button>
      </div>
        <div v-if="webcamError" class="webcamErrorIndicator">Your webcam is already busy by another program or has not been authorised. Please select your video and audio input source.</div>

      <div v-if="mainState === 'init'">
        <div class="liveIndicator">Click on the red circle to start streaming</div>
        <!--
        <b-button @click.prevent="changeFacingMode()" class="reverseCam">
          <font-awesome-icon icon="retweet"></font-awesome-icon>
          <font-awesome-icon v-if="facingMode === 'user'" icon="video"></font-awesome-icon>
          <font-awesome-icon v-if="facingMode === 'environment'" icon="user"></font-awesome-icon>
        </b-button>
        
        <b-button v-if="$route.name.indexOf('captureWindow') === -1 && $route.name !='delivery2'" class="optionButton goBack" @click="stopAll()"><font-awesome-icon icon="arrow-left"></font-awesome-icon></b-button>
        -->
        <b-button class="optionButton goBack" @click="stopAll()" title="Back to New Live creation"><font-awesome-icon icon="arrow-left"></font-awesome-icon></b-button>
        <!--<b-button class="optionButton selectPlatforms" @click="showModal('platformsModal')" v-if="isCaptureOrDelivery === 0"><font-awesome-icon icon="stream"></font-awesome-icon></b-button>
        -->
        <!--<div class=" optionButtonLogo selectPlatformsLogo" @click="showModal('platformsModal')" v-if="isCaptureOrDelivery === 0"><b-img class="imgPlatforms" :src="require('@/assets/logo_Platforms.svg')"></b-img></div>-->
        <b-button class="optionButton selectPlatforms" @click="showModal('passwordModal')" v-if="isCaptureOrDelivery === 1"><font-awesome-icon icon="stream"></font-awesome-icon></b-button>
        
        <b-button @click.prevent="mainState='live';startRecording()" class="mainButton startLive" title="Start streaming"><font-awesome-icon :icon="['fas', 'circle']"></font-awesome-icon></b-button>
        
        <div v-if="isCaptureOrDelivery === 1" class="topRight">
          <b-button class="linkButton" @click="copyIframe()" title="Copy iFrame code to clipboard">
            <font-awesome-icon icon="file-export"></font-awesome-icon> IFrame
            <font-awesome-icon icon="clone"></font-awesome-icon> 
          </b-button>
          <b-button class="linkButton" @click="copyDirectLink()" title="Copy direct link to clipboard">
            <font-awesome-icon icon="link"></font-awesome-icon> Direct Link
            <font-awesome-icon icon="clone"></font-awesome-icon> 
          </b-button>
        </div>



      </div>
      
      <div v-if="mainState === 'live'">
        <div v-if="liveState === 'stopped'" class="liveIndicator">Starting...</div>
        <div v-if="liveState === 'connecting'" class="liveIndicator">Connecting...</div>
        <div v-if="liveState === 'encoding'" class="liveIndicator">Stream starting...</div>
        <div v-if="liveState === 'error'" class="liveIndicator">Error, stream stopped.</div>
        <div v-if="liveState === 'lost'" class="liveIndicator">Connexion lost.</div>
        <div v-if="liveState === 'live'" class="liveIndicator">	
          <font-awesome-icon style="color: #ba0000" :icon="['fas', 'circle-notch']" spin ></font-awesome-icon>
          Live {{displayedElapsedTime}}
        </div>
        <!--
        <b-button @click.prevent="changeFacingMode()" class="reverseCam">
          <font-awesome-icon icon="retweet"></font-awesome-icon>
          <font-awesome-icon v-if="facingMode === 'user'" icon="video"></font-awesome-icon>
          <font-awesome-icon v-if="facingMode === 'environment'" icon="user"></font-awesome-icon>
        </b-button>
        -->

      
        <!--
        <b-button v-if="liveState === 'lost' || liveState === 'error'" @click.prevent="startRecording()" class="refreshLive"><font-awesome-icon icon="redo"></font-awesome-icon></b-button>
        -->
        <b-button  @click.prevent="stopAll()" class="mainButton stopLive" title="Stop streaming"><font-awesome-icon icon="stop"></font-awesome-icon></b-button>
        
        <div v-if="isCaptureOrDelivery === 1 || isCaptureOrDelivery === 0" class="topRight">
          <b-button class="linkButton" @click="copyIframe()" title="Copy iFrame code to clipboard">
            <font-awesome-icon icon="file-export" />&nbsp; IFrame&nbsp;
            <font-awesome-icon icon="clone" /> 
          </b-button>
          <b-button class="linkButton" @click="copyDirectLink()" title="Copy direct link to clipboard">
            <font-awesome-icon icon="link" />&nbsp; Direct Link&nbsp;
            <font-awesome-icon icon="clone" /> 
          </b-button>
        </div>
        <!--<b-button class="linkButton" >
          <font-awesome-icon icon="users" />&nbsp; No-delay: {{directConsumers}}&nbsp; 
        </b-button>-->
        <div v-if="isCaptureOrDelivery === 1 || isCaptureOrDelivery === 0" class="subTopRight">
          <b-form-select v-model="maxDirectConsumers" class="linkButton" @change="updateNoDelayViewers">
              <b-form-select-option :value="0">Max no-delay: 0</b-form-select-option>
              <b-form-select-option :value="5">Max no-delay: 5</b-form-select-option>
              <b-form-select-option :value="10">Max no-delay: 10</b-form-select-option>
              <b-form-select-option :value="15">Max no-delay: 15</b-form-select-option>
              <b-form-select-option :value="20">Max no-delay: 20</b-form-select-option>
              <b-form-select-option :value="25">Max no-delay: 25</b-form-select-option>
              <b-form-select-option :value="30">Max no-delay: 30</b-form-select-option>
          </b-form-select>
        </div>

        <b-button  @click.prevent="isFeedback = true" v-if="liveState === 'live' && isFeedback === false && isMobile === false && isCaptureOrDelivery !== 1" class="feedbackLiveIndicator">
          <font-awesome-icon style="color:#2F90B0" icon="external-link-alt" />        
          Stream preview
        </b-button>
        <b-button  @click.prevent="isFeedback = false" v-if="liveState === 'live' && isFeedback === true && isMobile === false && isCaptureOrDelivery !== 1" class="feedbackLiveIndicator">
          <font-awesome-icon style="color:red" icon="times" />&nbsp;
          Close preview
        </b-button>

        <div class="feedbackContainer" v-if="isFeedback">
          <iframe style="width:100%;height:100%;" class="feedbackIframe" :src="resultIframe"></iframe>
        </div>
      </div>

      <div v-if="mainState === 'init' || mainState === 'live'">
        <b-button id="selectAudioDevice" class="optionButton selectAudio" title="Select your microphone"><font-awesome-icon icon="microphone"></font-awesome-icon></b-button>
        <b-button id="selectVideoDevice" class="optionButton selectCamera" title="Select your camera"><font-awesome-icon icon="video"></font-awesome-icon></b-button>
        <b-popover target="selectAudioDevice" triggers="click" placement="top">
          <template #title>Select your microphone</template>
          <b-list-group class="list-devices">
            <b-list-group-item v-for="device in audioDeviceList" @click.prevent="(selectedAudioDevice !== device.text)?updateDevice({audio: {device: device.device, value:device.value}}):''" v-bind:key="device.value" :active="selectedAudioDevice === device.text" class="clickable" v-bind:class="{hoverReact: selectedAudioDevice !== device.text}">
              {{device.text}}
            </b-list-group-item>
          </b-list-group>
        </b-popover>
        <b-popover target="selectVideoDevice" triggers="click" placement="top">
          <template #title>Select your camera</template>
          <b-list-group class="list-devices">
            <b-list-group-item v-for="device in videoDeviceList" @click.prevent="(selectedVideoDevice !== device.text)?updateDevice({video: {device: device.device, value:device.value}}):''" v-bind:key="device.value" :active="selectedVideoDevice === device.text" class="clickable" v-bind:class="{hoverReact: selectedVideoDevice !== device.text}">
              {{device.text}}
            </b-list-group-item>
          </b-list-group>
        </b-popover>
      </div>

    <b-modal ref="platformsModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">External streaming services</h4>
      </div>
        <b-row class="justify-content-center marginaltop">
          <b-button class="col-md-4" variant="green" @click="addPlatform">Add a platform</b-button>
        </b-row>
        <b-row class="justify-content-around"  align-v="stretch">
            <b-col v-for="external in externalStreams" v-bind:key="external.name" class="col-lg-5 col-md-6 col-sm-6 col-12" style="margin-top: 15px;" v-bind:class="{'borderedyt': external.platform === 'youtube', 'borderedfb':external.platform === 'facebook', 'borderedtwitch': external.platform === 'twitch', 'borderedother':external.platform === 'other'}">
              <b-row class="align-items-center">
                <b-col cols="10">
                  <b-form-select class="marginaltopsm" v-model="external.platform" :options="externalOptions"></b-form-select>
                  <b-form-input v-if="external.platform === 'other'" class="marginalsm" v-model="external.url" placeholder="Platform url:"></b-form-input>
                  <b-form-input class="marginalsm" v-model="external.key" placeholder="Stream key:"></b-form-input>
                </b-col>
                <b-col cols="2">
                  <b-row class="justify-content-center">
                    <b-button @click="removeExternalStream(external.name)" variant="redsmall">X</b-button>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
        </b-row>
        <b-row class="justify-content-center marginaltop">
          <b-button class="col-md-4" variant="quanteec" @click="hideModal('platformsModal')">Close</b-button>
        </b-row>
  </b-modal>

  <b-modal ref="passwordModal" hide-footer title="Enter stream name and stream password">
      <b-form @submit.prevent="hideModal('passwordModal')">
        <b-form-group v-if="!isRoomAvailable"
        id="input-group-1"
        label="Stream name"
        label-for="input-1"
        description="Name of the stream"
      >
        <b-form-input
          id="input-1"
          v-model="roomName"
          type="text"
          placeholder="Enter stream name"
          required
        ></b-form-input>
      </b-form-group>
      <p v-if="isRoomAvailable">Stream name: <strong>{{title}}</strong></p>

      <b-form-group id="input-group-2" label="Password:" label-for="input-2">
        <b-form-input
          id="input-2"
          type="password"
          v-model="password"
          placeholder="Enter password"
          required
        ></b-form-input>
      </b-form-group>
        <b-row class="justify-content-center marginaltop">
          <b-button class="col-md-4" variant="msstreamblue" type="submit">Ok</b-button>
        </b-row>
      </b-form>
      
  </b-modal>

  <b-modal ref="confirmClickExport" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'file-export']" />
        Video iFrame Code 
      </h4>
    </div>
    <p style="line-height:normal">iFrame code of video: <span style="color: #2F90B0">iFrame code</span> is copied to Clipboard.</p>
    <b-row class="justify-content-around">
      <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('confirmClickExport')">
        <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
        Close
      </b-btn>
    </b-row>
  </b-modal>
  
  <b-modal ref="confirmClickDirectLink" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'link']" />
        Video direct link 
      </h4>
    </div>
    <p style="line-height:normal">Direct link of video: <span style="color: #2F90B0">Direct link</span> is copied to Clipboard.</p>
    <b-row class="justify-content-around">
      <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('confirmClickDirectLink')">
        <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
        Close
      </b-btn>
    </b-row>
  </b-modal>

<!--
  <b-modal ref="copied" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">Copied</h4>
      </div>
      <p style="line-height:normal">Link copied</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="msstreamblue" block @click="cleanMyTimeout();hideModal('copied')">Ok</b-btn>
      </b-row>
  </b-modal>
-->
  <b-modal ref="roomExist" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">Error Live Stream</h4>
      </div>
      <p style="line-height:normal">A live stream with this id is already being received</p>
      <b-row class="justify-content-center">
          <b-btn class="col-md-3 col-5" variant="quanteeclg" block @click="hideModal('roomExist')">
            <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
            Close
          </b-btn>
      </b-row>
  </b-modal>
      
    </div>
  </div>
</div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import VideoService from '@/services/video.service';
import {BASE_URL, EMBED_URL, BASE_RTC} from '@/services/base-url';
import {v4 as uuidv4} from 'uuid';
import { Device } from 'mediasoup-client';

var videoService = new VideoService();
var autoID_init = uuidv4().split("-").shift();

// Used for any webcam video.
const WEBCAM_SIMULCAST_ENCODINGS =
[
  //{ maxBitrate: 200000 },
	/*{ maxBitrate: 500000 },
  { maxBitrate: 1000000 },*/
  { maxBitrate: 3000000 },
];

const WEBCAM_SIMULCAST_ENCODINGS_DELIVERY =
[
  //{ maxBitrate: 1000000 },
  { maxBitrate: 4000000 }
];

// Used for VP9 webcam video.
const WEBCAM_KSVC_ENCODINGS =
[
	{ scalabilityMode: 'S3T3_KEY' }
];

const CODEC_OPTIONS = {
  videoGoogleStartBitrate: 1000
};

export default {
  name: 'CaptureComponent',
  components: {
    'FadeLoader': FadeLoader
  },
  data: function() {
    return {
      //LIVE
      mainState: 'pre',
      facingMode: "user",
      liveState: "stopped",
      device: null,
      ws: null,
      mediaRecorder: undefined,
      streamStarted: false,
      mediaStreamObj: undefined,
      videoTrack: undefined,
      audioTrack: undefined,
      newmediaRecorder: undefined,
      newmediaStreamObj: undefined,
      newRecorderCreated: false,
      intervalKey: undefined,
      intervalCheckVideoLive: undefined,
      intervalReconnect: undefined,
      intervalReconnectDuration: 2,
      selectedVideoDevice: undefined,
      selectedAudioDevice: undefined,
      videoDeviceList: [],
      audioDeviceList: [],
      isPreviewMuted: true,
      quanteecVideo: undefined,
      resultIframe: '',
      isFeedback: false,
      sendTransport: undefined,
      transportCallbacks: {
        connect: {},
        produce: {}
      },
      producerVideo: null,
      producerAudio: null,
      iMobile: false,
      isKeepVoD: true,
      isPassword: false,
      directConsumers: 0,

      //OTHER
      isPageClosed: false,
      title: `Video_${autoID_init}`,
      externalStreams: [],
      externalOptions: [
        {
          text: "Youtube",
          value: "youtube"
        },
        {
          text: "Facebook",
          value: "facebook"
        },
        {
          text: "Twitch",
          value: "twitch"
        },
        {
          text: "Other",
          value: "other"
        }
      ],

      autoID: autoID_init,
      autoUrl: 'rtmp://stream.quanteec.com:1935/live',
      hasDisplayMedia: true,
      isCaptureOrDelivery: 0,
      isSetupReady: false,
      isRoomAvailable: false,
      roomName: '',
      password: '',
      webcamError: false,
      inputData: {},
      isStream: true,
      maxDirectConsumer: 5,
      displayedElapsedTime: "00:00",
      startTimer: null,
      liveTimer: null,

    }
  },
  beforeDestroy() {
    this.isPageClosed = true;
    try {
      clearInterval(this.intervalKey);
    } catch(e) {}
    try {
      clearInterval(this.intervalCheckVideoLive);
    } catch(e) {}
    try {
        clearTimeout(this.intervalReconnect);
      } catch(err){}
    try {
      this.ws.close();
    } catch(err) {}
    try {
      this.stopMediaStreamTracks();
    } catch(err) {}
  },
  mounted(){
    let mobileAndTabletCheck = function() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };
    let self = this;

    window.addEventListener('message', (e) => {
      // Get the sent data
        if (e.origin !== window.origin) {
          return;
        }
        const data = e.data;
        if(data === "closePreview") {
          self.previewVideo = false;
        } else {
          try {
            self.inputData = JSON.parse(data);
            self.isKeepVoD = self.inputData.keepLive;
            self.isStream = (self.inputData.delay !== "no")
            self.isPassword = self.inputData.isPassword;
            self.password = self.inputData.password;
            self.maxDirectConsumers = (self.inputData.delay !== "yes") ? 5 : 0;
            for (let idyt in self.inputData.external_youtube) {
              if (!!self.inputData.external_youtube[idyt].key) {
                self.externalStreams.push({
                  name: self.$auth.getMyUser().clientname + "_stream_" + self.externalStreams.length,
                  platform: "youtube",
                  key: self.inputData.external_youtube[idyt].key
                })
              }
            }
            for (let idyt in self.inputData.external_facebook) {
              if (!!self.inputData.external_facebook[idyt].key) {
                self.externalStreams.push({
                  name: self.$auth.getMyUser().clientname + "_stream_" + self.externalStreams.length,
                  platform: "facebook",
                  key: self.inputData.external_facebook[idyt].key
                })
              }
            }
            for (let idyt in self.inputData.external_twitch) {
              if (!!self.inputData.external_twitch[idyt].key) {
                self.externalStreams.push({
                  name: self.$auth.getMyUser().clientname + "_stream_" + self.externalStreams.length,
                  platform: "twitch",
                  key: self.inputData.external_twitch[idyt].key
                })
              }
            }
          } catch(err) {}
        }

      });
    window.parent.postMessage('getLiveInput', window.origin);

    this.isMobile = mobileAndTabletCheck();

    this.quanteecVideo = {
      uuid: this.$route.params["uuid"]
    };
    if (this.$route.params["uuid"]) {
      this.isRoomAvailable = true;
    }
    if (this.$route.query && this.$route.query["title"]) {
      this.title = this.$route.query["title"];
      
    }

    /*if (this.$route.query && this.$route.query["keeplive"]) {
      this.isKeepVoD = (this.$route.query["keeplive"] === "true");
    }*/

    /*if (this.$route.query && this.$route.query["password"]) {
      this.isPassword = (this.$route.query["password"] === "true");
    }*/

    /*this.roomName = this.$route.params["roomID"] || '';
    if (this.$route.params["roomID"] && this.$route.params["roomID"] !== null && this.$route.params["roomID"] !== "") {
      this.isRoomAvailable = true;
    }*/
    if (this.$route.name === 'delivery' || this.$route.name === 'delivery2') {
      this.isCaptureOrDelivery = 1;
      if (this.isPassword) {
          this.showModal('passwordModal')
      }
    }
    if (this.quanteecVideo.uuid) {
      this.intervalCheckVideoLive = setInterval(this.checkVideo, 2000);
    }
    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
    }

    // Some browsers partially implement mediaDevices. We can't just assign an object
    // with getUserMedia as it would overwrite existing properties.
    // Here, we will just add the getUserMedia property if it's missing.
    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = function(constraints) {

        // First get ahold of the legacy getUserMedia, if present
        var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        // Some browsers just don't implement it - return a rejected promise with an error
        // to keep a consistent interface
        if (!getUserMedia) {
          return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
        }

        // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
        return new Promise(function(resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      }
    }
    if (navigator.mediaDevices.getDisplayMedia === undefined) {
       var getDisplayMedia = navigator.getDisplayMedia || navigator.webkitGetDisplayMedia || navigator.mozGetDisplayMedia;

      if (!getDisplayMedia) {
        this.hasDisplayMedia = false;
      }
      navigator.mediaDevices.getDisplayMedia = function(constraints) {

        // First get ahold of the legacy getUserMedia, if present
        var getDisplayMedia = navigator.getDisplayMedia || navigator.webkitGetDisplayMedia || navigator.mozGetDisplayMedia;

        // Some browsers just don't implement it - return a rejected promise with an error
        // to keep a consistent interface
        if (!getDisplayMedia) {
          return Promise.reject(new Error('getDisplayMedia is not implemented in this browser'));
        }

        // Otherwise, wrap the call to the old navigator.getDisplayMedia with a Promise
        return new Promise(function(resolve, reject) {
          getDisplayMedia.call(navigator, constraints, resolve, reject);
        });
      }
    }


    let beginDevice = () => {
      self.updateDevice().then(() => {
        self.mainState = "init"
        self.listDevices();
      }).catch((err) => {
        self.mainState = "init"
        self.listDevices();
        self.webcamError = true;
      });
    }

    if (document.readyState == "complete") { 
      beginDevice()
    } else {
      document.onreadystatechange = () => { 
        if (document.readyState == "complete") { 
          beginDevice();
        } 
      }
    }
  }, 
  methods: {
    manageTimeoutReconnect() {
      try {
        clearTimeout(this.intervalReconnect);
      } catch(err){}
      this.intervalReconnect = undefined;
      if (!this.isPageClosed) {
        this.intervalReconnect = setTimeout(this.startRecording, this.intervalReconnectDuration * 1000);
      }
    },
    stopAll() {
      if(this.$route.name.indexOf("captureWindow") > -1 || this.$route.name === "delivery2")
      {
        window.parent.postMessage("closePreview", window.origin);
      } else if (this.quanteecVideo && this.quanteecVideo.uuid) {
        this.isPageClosed = true;
        this.$router.push('/player/' + this.quanteecVideo.uuid);
      } else {
        this.isPageClosed = true;
        this.$router.push('/');
      }
    },
    goBack() {
      if(this.$route.name.indexOf("captureWindow") > -1 || this.$route.name === "delivery2")
      {

      }else{
        this.isPageClosed = true;
        this.$router.push('/');
      }
    },
    checkVideo() {
      let self = this;
      videoService.getVideoById(this.quanteecVideo.uuid, this.$auth.token()).then((video) => {
        self.quanteecVideo = video;
        if (video.encodingStatus === "encoding" && self.liveState !== "error" && self.liveState !== "lost") {
          if (self.liveState !== 'live' && video.startDateLive) {
            self.startTimer = new Date(video.startDateLive);
            self.displayedElapsedTime = self.getElapsedTime(self.startTimer)
            try {
              clearInterval(self.timer);
            } catch(err) {}
            self.timer = setInterval(() => {
              self.displayedElapsedTime = self.getElapsedTime(self.startTimer);
            }, 1000);
            self.liveState = "live";
          }
          
        }
        if (['stopped'].indexOf(video.encodingStatus) > -1  && self.liveState === 'live') {
          self.liveState = "error";
        }
        if (['encoded', 'error'].indexOf(video.encodingStatus) > -1) {
          self.liveState = "error";
        }
      }).catch((err) => {
        self.liveState = "error";
      })
    },
    listDevices() {
      return new Promise((done, reject) => {
        let self = this;
        navigator.mediaDevices.enumerateDevices().then(function (devices) {
          self.videoDeviceList = [];
          self.audioDeviceList = [];
          devices.forEach(function (device) {
            if (device.kind === "videoinput") {
              self.videoDeviceList.push({device: device, value: device.label, text: device.label});
            } else if (device.kind === "audioinput") {
              self.audioDeviceList.push({device: device, value: device.label, text: device.label});
            }
            //if (device.kind === "videooutput") {
            //  self.videoDeviceList.push({device: device, value: device.label  + ' |out', text: device.label + ' |out'});
            //} else if (device.kind === "audiooutput") {
            //  self.audioDeviceList.push({device: device, value: device.label  + ' |out', text: device.label + ' |out'});
            //}
          });
          if (self.hasDisplayMedia) {
            self.videoDeviceList.push({value: 'displayMedia', text: "Capture screen / Window"});
            self.audioDeviceList.push({value: 'displayMedia', text: "Capture audio from application"});
          }
          done();
        }).catch(function (err) {
          console.log(err.name, err.message);
          reject();
        });
      });
    },
    affectStreamToVid(str, vid) {
			if ("srcObject" in vid) {
				vid.srcObject = str;
			} else {
				vid.src = window.URL.createObjectURL(str);
			}
    },
    changeFacingMode() {
      if (this.facingMode === 'environment') {
        this.facingMode = "user";
      } else {
        this.facingMode = "environment";
      }
      this.updateDevice({video: {facingMode: this.facingMode}}).catch(err => {});
    },
    stopVideoTrack() {
      try {
        this.videoTrack.stop();
      } catch(err) {}
    },
    stopAudioTrack() {
      try {
        this.audioTrack.stop();
      } catch(err) {}
    },
    stopMediaStreamTracks() {
      try {
        this.videoTrack.stop();
      } catch(err) {}
      try {
        this.audioTrack.stop();
      } catch(err) {}
    },
    updateDevice(options) {
      let self = this;
      let hasAudio = false;
      let hasVideo = false;
      return new Promise((done, reject) => {
        if (options) {
          if (options.video) {
            hasVideo = true;
          }
          if (options.audio) {
            hasAudio = true;
          }
        } else {
          hasVideo = true;
          hasAudio = true;
        }

        self.useDevice(options).then(() => {
          if (self.mainState === "live") {
            if (hasVideo) {
              self.changeProducerVideo();
            }
            if (hasAudio) {
              self.changeProducerAudio();
            }
          }
          done();
        }).catch(err => {
          reject(err);
        })
      }); 
    },
    useDevice(options) {
      let self = this;
      return new Promise((done, reject) => {
        let video = self.$refs['vidView'];
        let isDisplay = false;
        let constraintObj = {
          audio: true,
          video: {
            width: { min: 100, ideal: 2000, max: 5000 },
            height: { min: 100, ideal: 2000, max: 5000 },
            frameRate: { ideal: 30, max: 30 }
          }
        };

        if (options) {
          // Pas d'audio
          if (!options.audio) {
            constraintObj.audio = false;
          }

          // Pas de video
          if (!options.video) {
            constraintObj.video = false;
          }

          // Audio
          if (options.audio) {
            if (options.audio === true) {
              constraintObj.audio = true;
              // audioTest
              constraintObj.audio = {
                autoGainControl: false,
                channelCount: 2,
                echoCancellation: false,
                latency: 0,
                noiseSuppression: false,
                sampleRate: 48000,
                sampleSize: 16,
              }
            }
            if (options.audio.device) {
              if (options.audio.device.label === self.selectedAudioDevice) {
                constraintObj.audio === false;
              } else {
                //audioTest
                constraintObj.audio = { 
                  deviceId: options.audio.device.deviceId,
                  autoGainControl: false,
                  channelCount: 2,
                  echoCancellation: false,
                  latency: 0,
                  noiseSuppression: false,
                  sampleRate: 48000,
                  sampleSize: 16,
                };
              }
            }
            if (options.audio.value === "displayMedia") {
              isDisplay = true;
            }
          }

          

          // Video
          if (options.video) {
            if (options.video.facingMode) {
              constraintObj.video.facingMode = options.video.facingMode;
            }
            if (options.video.device) {
              if (options.video.device.label === self.selectedVideoDevice) {
                constraintObj.video === false;
              } else {
                constraintObj.video.deviceId = options.video.device.deviceId;
              }
            }
            if (options.video.value === "displayMedia") {
              isDisplay = true;
            }
            
          }
        } else {
          constraintObj.video.facingMode = self.facingMode;
        }

        if (constraintObj.video) {
          self.stopVideoTrack();
        }

        if (constraintObj.audio) {
          self.stopAudioTrack();
        }

        if (constraintObj.video === false && constraintObj.audio === false) {
          done();
        } else if (!isDisplay) {
          navigator.mediaDevices.getUserMedia(constraintObj).then(function (stream) {
            let finalStream = new MediaStream();
            stream.getTracks().forEach((track) => {
              if (track.kind === "video") {
                self.selectedVideoDevice = track.label;
                self.videoTrack = track;
              }
              if (track.kind === "audio") {
                self.selectedAudioDevice = track.label;
                self.audioTrack = track;
                console.log('new audio', track)
              }
            });
            try {
              finalStream.addTrack(self.videoTrack);
              self.webcamError = false;
            } catch(err) {
              self.webcamError = true;
            }
            try {
              finalStream.addTrack(self.audioTrack);
            } catch(err) {}

            self.affectStreamToVid(finalStream, video);

            video.onloadedmetadata = function (ev) {
              video.play(); // video preview
              done();
            };
          }).catch(function (err) {
            reject(err);
          });
        } else {
          let myConstraintObj = {
            video: true, 
            audio: {
              autoGainControl: false,
              channelCount: 2,
              echoCancellation: false,
              latency: 0,
              noiseSuppression: false,
              sampleRate: 48000,
              sampleSize: 16,
            }
          };
          if (constraintObj.video) {
            self.selectedVideoDevice = "Capture screen / Window";
          }
          if (constraintObj.audio) {
            self.selectedVideoDevice = "Capture audio from application";
          }
          navigator.mediaDevices.getDisplayMedia(myConstraintObj).then(function (stream) {
            let finalStream = new MediaStream();
            stream.getTracks().forEach((track) => {
              if (track.kind === "video" && constraintObj.video) {
                self.selectedVideoDevice = "Capture screen / Window";
                self.videoTrack = track;
              }
              if (track.kind === "audio" && constraintObj.audio) {
                self.selectedAudioDevice = "Capture audio from application";
                self.audioTrack = track;
                console.log('new audio', track)
              }
            });

            finalStream.addTrack(self.videoTrack);
            finalStream.addTrack(self.audioTrack);

            self.affectStreamToVid(finalStream, video);

            video.onloadedmetadata = function (ev) {
              video.play(); // video preview
              done();
            };
          }).catch(function (err) {
            reject(err);
          });
        }
      })
    },
   
    startRecording() {
      // Create init msg
      let self = this;
      let initmsg = {
          type: 'streamsetup',
          liveTitle: self.quanteecVideo.uuid,
          room: self.quanteecVideo.uuid,
          role: 'producer',
          maxDirectConsumers: this.maxDirectConsumers,
          quanteec: {
            credential: self.$auth.token(),
            stream: this.isStream,
            keepVoD: this.isKeepVoD
          },
          externalStreams: self.externalStreams
        };
      this.directConsumers = 0;
      if (self.isPassword) {
        initmsg.password =  this.password;
      }
      if (self.quanteecVideo.uuid !== undefined) {
        initmsg.quanteec.uuid = self.quanteecVideo.uuid;
      }
      
      /*if (self.isCaptureOrDelivery === 0) {
        
      } else if (self.isCaptureOrDelivery === 1){

      }*/    

      if (self.isPageClosed) {
        return;
      }

      // Websocket
      self.ws = new WebSocket(BASE_RTC);
      self.liveState = "connecting";
      self.ws.onopen = (event) => { // sending parameters
        self.ws.send(JSON.stringify(initmsg));
			};
			self.ws.onmessage = async (message) => {
        try {
          var data = JSON.parse(message.data);
          if (data.type) {
            switch (data.type) {
              case 'directConsumers':
                self.directConsumers = data.data;
                break;
              case 'roomExist':
                self.showModal('roomExist');
                self.ws.close();
                break;
              case 'quanteecVideo':
                self.quanteecVideo = data.video;
                self.resultIframe = `${EMBED_URL}/embeded.html?uuid=${data.video.uuid}&type=live&audio=0&autoplay=1&analyticsID=${self.$auth.getMyUser().client}`;
                self.platformUrl = BASE_URL;
                self.liveState = "encoding";
                //TO-DO ==> Commencer à mettre en place le timer ici
                try {
                  clearInterval(self.intervalCheckVideoLive);
                } catch(err) {

                }
                self.intervalCheckVideoLive = setInterval(self.checkVideo, 2000);
                break;
              case 'rtpCapabilities':
                let routerRtpCapabilities = data.data;
                let iOS = function () {
                  return [
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                  ].includes(navigator.platform)
                  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
                }
                if (iOS) {
                  // Modify urn:3gpp:video-orientation
                  routerRtpCapabilities.headerExtensions = routerRtpCapabilities.headerExtensions.filter((ext) => ext.uri !== 'urn:3gpp:video-orientation');
                }

                // DEVICE LOAD
                if (self.device === null) {
                  self.device = new Device();
                  self.device.load({ routerRtpCapabilities: routerRtpCapabilities}).then(() => {
                    if (!self.device.canProduce('video')) {
                      console.warn('cannot produce video');
                    } else {
                      self.ws.send(JSON.stringify({type: 'createTransport'}));
                    }

                    self.device.observer.on('close', () => {
                      console.log("device closed");
                    })

                  }).catch((err) => {});
                } else {
                  self.ws.send(JSON.stringify({type: 'createTransport'}));
                }
                break;
              case 'streamCreated':
                  console.log("STREAM CREATED")
                  self.ws.send(JSON.stringify({type: 'requestRTPCapabilities'}));
                break;
              case 'transportCreated':
                console.log('TRANSPORT CREATED', data);
                let sendTransport = await self.device.createSendTransport(data.data.params)
                  self.sendTransport = sendTransport;

                  sendTransport.on('connect', (transportData, callback, errback) => {
                    try {
                      let callbackID = uuidv4();
                      self.ws.send(JSON.stringify({
                          type: 'connectTransport',
                          callbackID: callbackID,
                          data: {
                            transportId: sendTransport._id,
                            dtlsParameters: transportData.dtlsParameters
                          }
                        }
                      ));
                      
                      self.transportCallbacks.connect[callbackID] = callback;
                    } catch(err) {
                      errback(err);
                    }
                  })

                  sendTransport.on('produce', (transportData, callback, errback) => {
                    console.log("PRODUCING")
                    try {
                      let callbackID = uuidv4();
                      self.ws.send(JSON.stringify({
                          type: 'produceTransport',
                          callbackID: callbackID,
                          data: {
                            transportId: sendTransport.id,
                            kind: transportData.kind,
                            rtpParameters: transportData.rtpParameters,
                            appData: transportData.appData
                          }
                        }
                      ));
                       self.transportCallbacks.produce[callbackID] = callback;
                    } catch(err) {
                      errback(err);
                    }
                  })

                  sendTransport.on('connectionstatechange', function (state) {
                    switch (state) {
                      case 'connecting':

                        break;

                      case 'connected':

                        break;

                      case 'failed':
                        console.log("TRANSPORT FAILDED")
                        break;

                      default:
                        break;
                    }
                  });

                await self.createProducers();
                break;
              case 'transportConnected':
                  console.log('TRANSPORT CONNECTED on server', data)
                  self.transportCallbacks.connect[data.callbackID]();
                  delete self.transportCallbacks.connect[data.callbackID];
                break;
              case 'transportCreated':
                  console.log('TRANSPORT CREATED on server', data);
                break;
              case 'producerCreated':
                console.log('PRODUCER CREATED on server', data)
                self.transportCallbacks.produce[data.callbackID]({id: data.data.id});
                delete self.transportCallbacks.produce[data.callbackID];
                break;
              case 'transportLost':
                self.ws.send(JSON.stringify({type: 'createTransport'}));
                break;
              case 'processLost':
                self.liveState = "error";
                self.ws.close();
                break;
              default:
                break;
            }
            
          }
        } catch(err) {
          console.log("Create send Transport error", err);
        }
      };

      let closeFunction = async () => {
        let needSubmit = false;
        try {
          clearInterval(self.intervalCheckVideoLive);
        } catch(err) {

        }
        self.transportCallbacks = {
          connect: {},
          produce: {}
        }

        try {
          self.sendTransport.close()
        } catch(err) {}
        try {
          self.producerAudio.close()
        } catch(err) {}
        try {
          self.producerVideo.close()
        } catch(err) {}
        
        self.liveState = "lost";
        let video = self.$refs['vidView'];
        if (video !== undefined && video.networkState !== undefined && video.networkState === 1) {
          self.refreshVideo();
        }
        self.manageTimeoutReconnect();
      }
      self.ws.onclose = closeFunction;
      self.ws.onerror = closeFunction;
    },
    updateNoDelayViewers() {
      try {
        this.ws.send(JSON.stringify({type: 'updateMaxDirectConsumers', data: this.maxDirectConsumers}));
      } catch(err) {
        console.log(err);
      }
    },
    refreshVideo() {
      let self = this;
      let videoDevice = self.videoDeviceList.find(x => {
        return x.text === self.selectedVideoDevice
      });
      let audioDevice = self.audioDeviceList.find(x => {
        return x.text === self.selectedAudioDevice
      });
      self.selectedVideoDevice = undefined;
      self.selectedAudioDevice = undefined;

      let result = {};

      if (videoDevice && videoDevice !== null) {
        result.video = {
          device: videoDevice.device
        }
      }

      if (audioDevice && audioDevice !== null) {
        result.audio = {
          device: audioDevice.device
        }
      }

      self.useDevice(result);
    },
    createProducers: async function() {
      let self = this;
      let videoTrack = self.videoTrack;
      let audioTrack = self.audioTrack;
      try {
        let firstVideoCodec = self.device
					.rtpCapabilities
					.codecs
          .find((c) => c.kind === 'video');
          
        let producerVideo = await self.sendTransport.produce({
          track: videoTrack,
          encodings: (firstVideoCodec.mimeType.toLowerCase() === 'video/vp9') ? WEBCAM_KSVC_ENCODINGS : (this.isCaptureOrDelivery === 0) ? WEBCAM_SIMULCAST_ENCODINGS : WEBCAM_SIMULCAST_ENCODINGS_DELIVERY,
          codecOptions: CODEC_OPTIONS
        });
        this.producerVideo = producerVideo;
      }catch(err) {
        console.log(err);
      }
      try {
        let producerAudio = await self.sendTransport.produce({
          track: audioTrack,
          encodings: [{maxBitrate: 510000}],
          codecOptions: {
            opusStereo: true, 
            opusFec: false, 
            opusDtx: false, 
            opusMaxPlaybackRate: 510000,
            opusMaxAverageBitrate: 510000
          },
        });
        this.producerAudio = producerAudio;
      } catch(err) {
        console.log(err);
      }
      if (this.isCaptureOrDelivery === 0) {
        self.ws.send(JSON.stringify({type: 'startStream'}));
        window.parent.postMessage('videoListRefresh', window.origin);
        self.displayedElapsedTime = "00:00"
        self.startTimer = new Date();
        self.timer = setInterval(() => {
          self.displayedElapsedTime = self.getElapsedTime(self.startTimer);
        }, 1000);
      } else if (this.isCaptureOrDelivery === 1) {
        self.liveState = "live"
        self.displayedElapsedTime = "00:00"
        self.startTimer = new Date();
        self.timer = setInterval(() => {
          self.displayedElapsedTime = self.getElapsedTime(self.startTimer);
        }, 1000);
        window.parent.postMessage('videoListRefresh', window.origin);
      }
    },
    getElapsedTime: function (startTime) {

        // Record end time
        let endTime = new Date();

        // Compute time difference in milliseconds
        let timeDiff = endTime.getTime() - startTime.getTime();
        if (timeDiff < 0) {
          timeDiff = 0;
        }

        // Convert time difference from milliseconds to seconds
        timeDiff = timeDiff / 1000;

        // Extract integer seconds that dont form a minute using %
        let seconds = Math.floor(timeDiff % 60); //ignoring uncomplete seconds (floor)

        // Pad seconds with a zero if neccessary
        let secondsAsString = seconds < 10 ? "0" + seconds : seconds + "";

        // Convert time difference from seconds to minutes using %
        timeDiff = Math.floor(timeDiff / 60);

        // Extract integer minutes that don't form an hour using %
        let minutes = timeDiff % 60; //no need to floor possible incomplete minutes, becase they've been handled as seconds

        // Pad minutes with a zero if neccessary
        let minutesAsString = minutes < 10 ? "0" + minutes : minutes + "";

        // Convert time difference from minutes to hours
        timeDiff = Math.floor(timeDiff / 60);

        // Extract integer hours that don't form a day using %
        let hours = timeDiff % 24; //no need to floor possible incomplete hours, becase they've been handled as seconds

        // Convert time difference from hours to days
        timeDiff = Math.floor(timeDiff / 24);

        // The rest of timeDiff is number of days
        let days = timeDiff;

        let totalHours = hours + (days * 24); // add days to hours
        let totalHoursAsString = totalHours < 10 ? "0" + totalHours : totalHours + "";

        if (totalHoursAsString === "00") {
            return minutesAsString + ":" + secondsAsString;
        } else {
            return totalHoursAsString + ":" + minutesAsString + ":" + secondsAsString;
        }
    },
    changeProducerVideo: async function() {
      let self = this;
      let videoTrack = self.videoTrack;
      try {
        if (this.producerVideo && !this.producerVideo.closed) {
          await this.producerVideo.replaceTrack({ track: videoTrack });
        }
      } catch(err) {
        console.log("Can not change producer", err)
      }
    },
    changeProducerAudio: async function() {
      let self = this;
      let audioTrack = self.audioTrack;
      try {
        if (this.producerAudio && !this.producerAudio.closed) {
          await this.producerAudio.replaceTrack({ track: audioTrack });
        }
      } catch(err) {
        console.log("Can not change producer", err)
      }
    },
    hasPlatform(platform) {
      return (this.externalStreams.findIndex(x => x.platform === platform) > -1)
    },
    addPlatform() {
      let currentPlatform = "other";
      if(!this.hasPlatform("twitch")) {
        currentPlatform = "twitch";
      };
      if(!this.hasPlatform("facebook")) {
        currentPlatform = "facebook";
      };
      if(!this.hasPlatform("youtube")) {
        currentPlatform = "youtube";
      };

      this.externalStreams.push({
        name: this.$auth.getMyUser().clientname + "_stream_" + this.externalStreams.length,
        platform: currentPlatform,
        key: ""
      })
    },
    removeExternalStream(name) {
      let index = this.externalStreams.findIndex(x => x.name === name);
      if (index > -1) {
        this.externalStreams.splice(index, 1);
      }
    },
    cleanMyTimeout() {
      try {
        clearTimeout(this.timeoutModalCopied);
      } catch(err) {}
    },
    copyDirectLink() {
      this.cleanMyTimeout();
      this.$copyText(EMBED_URL + '/embeded.html?uuid=' + this.quanteecVideo.uuid + `&type=live&analyticsID=${this.$auth.getMyUser().client}`);
      this.showModal('confirmClickDirectLink')
      this.timeoutModalCopied = setTimeout(this.hideModal, 3 * 1000, 'confirmClickDirectLink');
    },
    copyIframe() {
      this.cleanMyTimeout();
      let src = EMBED_URL + '/embeded.html?uuid=' + this.quanteecVideo.uuid + `&type=live&analyticsID=${this.$auth.getMyUser().client}`;
      this.$copyText(`<iframe id="video-player" style="width:100%;height:100%" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" src="${src}"></iframe>`)
      this.showModal('confirmClickExport')
      this.timeoutModalCopied = setTimeout(this.hideModal, 3 * 1000, 'confirmClickExport');
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.clickable {
  cursor: pointer;
}

.hoverReact {
  &:hover{
    background-color: lightgrey;
  }
}

.liveIndicator {
  position: absolute;
  max-width: 100vw;
  background-color:rgba(#000000, 0.9);
//	box-shadow: 0px 0px 5px #fff;
	border-radius: 5px;
  padding: 5px 10px;
	color:#fff;
  z-index: 1;
  top: 18px;
  left: 10px;
  bottom: auto;
  right: auto;
  font-size: small;
}

.webcamErrorIndicator {
  position: absolute;
  max-width: 50vw;
  background-color:rgba(#000000, 0.9);
	box-shadow: 0px 0px 5px #fff;
	border-radius: 30px;
  padding: 2px 10px;
  border-style: none;
	color:#fff;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}

.reverseCam {
  position: absolute;
  background-color:rgba(#000000, 0.9);
	box-shadow: 0px 0px 5px #fff;
	border-radius: 30px;
  padding: 2px 10px;
  border-style: none;
	color:#fff;
  z-index: 1;
  top: 20px;
  right: 10px;
  bottom: auto;
  left: auto;
}

.feedbackLiveIndicator {
  position: absolute;
  background-color:rgba(#000000, 0.9);
	box-shadow: 0px 0px 5px #fff;
	border-radius: 5px;
  padding: 2px 10px;
  border-style: none;
	color:#fff;
  z-index: 1;
  bottom: 120px;
  right: 10px;
  top: auto;
  left: auto;
  border: 1px solid white !important;
  font-size: small;
  &:active {
    transform: scale(0.98);
  }
  &:hover {
    color: #048F94 !important;
    background-color: white !important;
    border: 1px solid #048F94 !important;
  }    

}

.topRight {
  position: absolute;
  max-width: 68vw;
  z-index: 1;
  top: 20px;
  left: auto;
  bottom: auto;
  right: 5px;
}
.subTopRight {
  position: absolute;
  max-width: 68vw;
  z-index: 1;
  top: 50px;
  left: auto;
  bottom: auto;
  right: 15px;
}

.linkButton {
  background-color:rgba(#000000, 0.9);
	box-shadow: 0px 0px 5px #fff;
	border-radius: 5px;
  padding: 2px 10px;
  border-style: none;
	color:#fff;
  margin: 0px 5px;
  font-size: 0.8em;
  border: 1px solid white !important;
  &:hover {
    color: #048F94 !important;
    background-color: white !important;
    border: 1px solid #048F94 !important;
  }
}

.preLive {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%,-50%);
}

.startLive {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%,-50%);
}

.stopLive {
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%,-50%);
}

.refreshLive {
  position: absolute;
  left: 8vw;
  bottom: 30px;
  transform: translate(-50%,-50%);
}

.selectCamera {
  position: absolute;
  left: 65vw;
  bottom: 50px;
  transform: translate(-50%,-50%);
}

.selectAudio {
  position: absolute;
  left: 35vw;
  bottom: 50px;
  transform: translate(-50%,-50%);
}


.selectPlatforms {
  position: absolute;
  top: 50%;
  left: 8vw;
  transform: translate(-50%,-50%);
}

.selectPlatformsLogo{
  position: absolute;
  top: 50%;
  left:8vw;
  transform: translate(-50%,-50%) scale(0.5);
  cursor: pointer;
  transition-property: transform;
  transition-duration: 400ms;

      &:hover {
        transform: translate(-50%,-50%) scale(0.70);
    }
  
}

.optionButtonLogo {
  background:rgba(#000000, 0.9);
	box-shadow: 0px 0px 6px #fff, 0px 0px 6px #fff;
	border-radius: 50%;
  border-style: none;
	color:#ffffff;
  z-index: 2;
  width: 250px;
  height: 250px;
  font-size: 30px;

  @media(max-width: 812px) {
    width: 125px;
    height: 125px;
    font-size: 15px;
  }
}

.imgPlatforms {
  position: absolute;
  top: 15%;
  left: 9%;

    @media(max-width: 812px) {
    width: 100px;
    height: 100px;
    font-size: 15px;
  }

}

.goBack {
  position: absolute;
  left: 8vw;
  bottom: 0px;
  transform: translate(-50%,-50%);
}

.setupContainer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  border: solid 2px white;
  width: 200px;
  height: 200px;
}

.feedbackContainer {
  position: fixed;
  bottom: 150px;
  right: 0px;
  top: auto;
  left: auto;
  z-index: 3;
  width: 40vw;
  padding-top: calc(40vw * 0.5625);
  background-color: black;
}

.feedbackIframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.feedbackClose {
  position: absolute;
  background:rgba(#000000, 0.9);
	box-shadow: 1px 2px 7px #ba0000, 1px 2px 7px #ba0000;
	border-radius: 50%;
  border-style: none;
	color:#ba0000;
  z-index: 2;
  width: 45px;
  height: 45px;
  right: 0px;
  top: 0px;
  font-size:20px;

  @media(max-width: 700px) {
    width: 30px;
    height: 30px;
    font-size: 13px;
  }
}

.previewVideo {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.video-container {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%; 
  overflow: hidden;
  background-color: black;
}

.myVideo {
  min-width: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  /* Center the video */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}


.optionButton {
  background:rgba(#000000, 0.9);
	box-shadow: 0px 0px 6px #fff, 0px 0px 6px #fff;
	border-radius: 50%;
  border-style: none;
	color:#ffffff;
  z-index: 2;
  width: 55px;
  height: 55px;
  font-size: 30px;
    &:hover {
    color: #048F94 !important;
    background-color: white !important;
  }    


  @media(max-width: 812px) {
    width: 40px;
    height: 40px;
    font-size: 15px;
  }
}

.mainButton {
  background:rgba(#000000, 0.9);
	box-shadow: 0px 0px 6px #ba0000, 0px 0px 6px #ba0000;
	border-radius: 50%;
  border-style: none;
	color:#ba0000;
  z-index: 2;
  width: 65px;
  height: 65px;
  font-size: 35px;
    &:hover {
    background-color: white !important;
  }    


  @media(max-width: 812px) {
    width: 45px;
    height: 45px;
    font-size: 20px;
  }
}

.list-devices{
    max-height: 200px;
    overflow-y:scroll;
    -webkit-overflow-scrolling: touch;
}

</style>